import { useMutation, useQuery } from '@tanstack/react-query';
import axios, { AxiosResponse } from 'axios';
import { PlanningsOperationEntity } from 'src/entities/PlanningsOperation.entity';

const requestPath = (startOn: string, endOn: string) => `/api/v3/plannings/${startOn}/operations?end_on=${endOn}`;

const getAll = (startOn: string, endOn: string) => async () => {
  const response: AxiosResponse<PlanningsOperationEntity[]> = await axios.get(requestPath(startOn, endOn));

  return response.data;
};

export const useQueryPlanningsOperations = (startOn: string, endOn: string) => useQuery(
  ['useQueryPlanningsOperations', { startOn, endOn }],
  getAll(startOn, endOn),
  {
    staleTime: Infinity,
    enabled: Boolean(startOn) && Boolean(endOn)
  }
);

export const useMutationPlanningOperations = () => ({
  operationSendMail: useMutation(
    ({ startOn, endOn, shiftTruckIds }: {
      startOn: string;
      endOn: string;
      shiftTruckIds: number[]
    }) => axios.post(`/api/v3/plannings/${startOn}/operatios/send_mail?end_on=${endOn}`, { shift_truck_ids: shiftTruckIds })
  )
});
